import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { colors, fonts, spacing, borderRadius } from '../../../constants';

/**
 * SectionCard Component
 * Reusable section card wrapper for query modal sections
 * 
 * @param {string} title - Section title
 * @param {ReactNode} children - Section content
 */
const SectionCard = ({ title, children }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        position: 'relative',
        p: spacing.sm,
        borderRadius: borderRadius.md,
        border: '1px solid rgba(14, 23, 42, 0.08)',
        borderTop: '4px solid rgba(14, 23, 42, 0.35)',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
        transition: 'all 0.2s ease-in-out',
        boxShadow: '0 18px 40px rgba(14, 23, 42, 0.08)',
        overflow: 'hidden',
        '&:hover': {
          boxShadow: '0 24px 48px rgba(14, 23, 42, 0.12)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: fonts.weightSemiBold,
          fontSize: fonts.fontSizeSm,
          color: colors.textPrimaryDark,
          mb: spacing.xs,
          pb: '4px',
          borderBottom: `1px solid ${colors.borderDefault}`,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {title}
      </Typography>
      <Box sx={{ mt: '4px', width: '100%' }}>
        {children}
      </Box>
    </Paper>
  );
};

export default SectionCard;
